import i18n from '@/i18n';
import store from '@/store';

const pageTreeHelper = {
  showTitle(name) {
    const camelCasePages = ['roomtypes', 'rateplans', 'mealplans'];
    const exceptionPages = ['profile', 'legal', 'follower', 'billing', 'userProperties'];
    if (!exceptionPages.includes(name) && !camelCasePages.includes(name)) {
      return i18n.t(`navbarTitles.${name}`);
    }
    if (exceptionPages.includes(name) && !camelCasePages.includes(name)) {
      return i18n.t(`permissions.${name}Title`);
    }
    return i18n.t(`navbarTitles.${this.camelCase(name)}`);
  },
  camelCase(string) {
    return string.slice(0, 4) + string[4].toUpperCase() + string.slice(5);
  },
  findPageById(pages, targetId) {
    for (let i = 0; i < pages.length; i += 1) {
      const page = pages[i];
      if (page.id === Number(targetId)) {
        return page;
      }

      if (page.sub_pages && page.sub_pages.length > 0) {
        const foundInSubPages = this.findPageById(page.sub_pages, targetId);
        if (foundInSubPages) {
          return foundInSubPages;
        }
      }
    }

    return null;
  },
  deletePageById(pages, targetId) {
    const index = pages.findIndex(({ id }) => id === Number(targetId));
    if (index !== -1) {
      pages.splice(index, 1);
    }
  },
  updatePageIndexById(pages, targetId, newIndex) {
    const index = pages.findIndex(({ id }) => id === Number(targetId));
    if (index !== -1) {
      const item = pages[index];
      pages.splice(index, 1);
      pages.splice(newIndex, 0, item);
    }
  },
  removePageFromParent(pages, parent, id) {
    let pageToRemove = null;
    if (parent === 'root') {
      pageToRemove = this.findPageById(pages, id);
      this.deletePageById(pages, id);
    } else {
      const parentPage = this.findPageById(pages, parent);
      if (parentPage) {
        pageToRemove = this.findPageById(parentPage.sub_pages, id);
        this.deletePageById(parentPage.sub_pages, id);
      }
    }

    return pageToRemove;
  },
  addPageToParent(pages, parent, page, index) {
    if (parent === 'root') {
      pages.splice(index, 0, page);
    } else {
      const parentPage = this.findPageById(pages, parent);
      if (parentPage) {
        parentPage.sub_pages.splice(index, 0, page);
      }
    }
  },
  /* eslint-disable */
  findSubPagesByName(pages, targetName) {
    for (const page of pages) {
      if (page.name === targetName && page.sub_pages) {
        return page.sub_pages;
      } if (page.sub_pages && page.sub_pages.length > 0) {
        const subPages = this.findSubPagesByName(page.sub_pages, targetName);
        if (subPages) {
          return subPages;
        }
      }
    }
    return null;
  },

  accessibleTabs(parent) {
    // special case for booking engine tabs if parent is booking engine and is disabled in the role
    if (
      parent === 'bookingengine' &&
      store.getters['user/property'].allPages.some(page => page.name === 'distributors')
    ) {
      return this.findSubPagesByName(store.getters['user/property'].allPages, parent).map((row) => ({
        id: row.name,
        tabID: row.id,
        title: i18n.t(`navbarTitles.${row.name}`),
      }));
    }

    if (store.getters['user/property'].pageTree) {
      return this.findSubPagesByName(store.getters['user/property'].pageTree, parent).map((row) => ({
        id: row.name,
        tabID: row.id,
        title: i18n.t(`navbarTitles.${row.name}`),
      }));
    }
    return [];
  },

  activeTab(parent) {
    const thirdLevelPages = this.accessibleTabs(parent);
    if (thirdLevelPages.length > 0) {
      return thirdLevelPages[0].id;
    }
    return null;
  },
};

export default pageTreeHelper;
